import PropTypes from 'prop-types'
import React from 'react'
import { FullNameCitizenField } from '../question_fields/FullNameCitizenField'

const Citizen = props => {
  const { index, name, question, disabled = false, margin } = props
  return <FullNameCitizenField index={index} {...question} name={name} disabled={disabled} margin={margin} />
}

const FullNameQuestion = {
  Citizen,
  name: 'FullNameQuestion'
}

export default FullNameQuestion

Citizen.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.number,
  margin: PropTypes.string,
  name: PropTypes.string,
  question: PropTypes.object
}
